// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ThirdPartyDataIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 56 56">
    <path
      fill="url(#third-party-data_svga)"
      fillRule="evenodd"
      d="M9.75 29.78a18.3 18.3 0 0 1 9.7-14.83q.18 1.2.7 2.28a16 16 0 0 0-8.02 12.16q-1.25.03-2.38.4m8.85 14.25a15.9 15.9 0 0 0 18.8 0q.83.87 1.89 1.5a18.2 18.2 0 0 1-11.3 3.9 18.2 18.2 0 0 1-11.28-3.9q1.05-.63 1.9-1.5m25.27-14.64a16 16 0 0 0-8.02-12.16q.52-1.08.7-2.28a18.3 18.3 0 0 1 9.7 14.83 9 9 0 0 0-2.38-.39"
      clipRule="evenodd"
    />
    <path
      fill="url(#third-party-data_svgb)"
      d="M43.66 45.05a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
    />
    <path
      fill="url(#third-party-data_svgc)"
      fillRule="evenodd"
      d="M12.34 31.05a7 7 0 1 1-.01 14 7 7 0 0 1 .01-14m0 2.33a4.67 4.67 0 1 0 .01 9.34 4.67 4.67 0 0 0 0-9.34"
      clipRule="evenodd"
    />
    <path
      fill="url(#third-party-data_svgd)"
      fillRule="evenodd"
      d="M28 6.57a7 7 0 1 1-.01 14.02 7 7 0 0 1 0-14.02m0 2.34a4.67 4.67 0 1 0 0 9.34 4.67 4.67 0 0 0 0-9.34"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="third-party-data_svga"
        x1={9.75}
        x2={45.12}
        y1={14.95}
        y2={50.55}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
      <linearGradient
        id="third-party-data_svgb"
        x1={36.66}
        x2={51.01}
        y1={31.05}
        y2={44.69}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
      <linearGradient
        id="third-party-data_svgc"
        x1={5.34}
        x2={19.69}
        y1={31.05}
        y2={44.68}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
      <linearGradient
        id="third-party-data_svgd"
        x1={21}
        x2={35.35}
        y1={6.57}
        y2={20.21}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "ThirdPartyData",
);
export default ThirdPartyDataIcon;
